/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductGroupsResponse as ModelsProductProductGroupsResponse } from '../../models/Models/Product/product-groups-response';

export interface V4ProductsProductGroupsGet$Plain$Params {
}

export function v4ProductsProductGroupsGet$Plain(http: HttpClient, rootUrl: string, params?: V4ProductsProductGroupsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsProductProductGroupsResponse>> {
  const rb = new RequestBuilder(rootUrl, v4ProductsProductGroupsGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsProductProductGroupsResponse>;
    })
  );
}

v4ProductsProductGroupsGet$Plain.PATH = '/v4/products/productGroups';
